<template>
  <main-layout>
    <template slot="header-title">Waves</template>

    <template slot="header-actions">
      <common-button
        @click="isOpenFormNewWave = true">Create a wave</common-button>
    </template>

    <template slot="main">

      <waves-ui-list />

      <waves-ui-modal-create  v-if="isOpenFormNewWave" :open="isOpenFormNewWave" :site="site" @close="closeFormNewWave"/>

    </template>
  </main-layout>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'WaveHome',

  props: {
  },

  data () {
    return {
      isOpenFormNewWave: false
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },

  watch: {
    site: {
      handler: 'initOnBoarding',
      immediate: true
    }
  },

  methods: {
    initOnBoarding () {
    },
    closeFormNewWave () {
      this.isOpenFormNewWave = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Wave/WaveList.vue